/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Settings_Close_LabelInputs */

const en_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Settings`)
};

const fr_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer les parametres`)
};

const de_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen schließen`)
};

const it_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi Impostazioni`)
};

const ru_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть настройки`)
};

const es_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar configuración`)
};

const zh_cn2_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭设置`)
};

const ja_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を閉じる`)
};

const hi_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स बंद करें`)
};

const pt_pt2_timing_sync_settings_close_label = /** @type {(inputs: Timing_Sync_Settings_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar configurações`)
};

/**
* | output |
* | --- |
* | "Close Settings" |
*
* @param {Timing_Sync_Settings_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_settings_close_label = /** @type {((inputs?: Timing_Sync_Settings_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Settings_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_settings_close_label(inputs)
	if (locale === "de") return de_timing_sync_settings_close_label(inputs)
	if (locale === "it") return it_timing_sync_settings_close_label(inputs)
	if (locale === "ru") return ru_timing_sync_settings_close_label(inputs)
	if (locale === "es") return es_timing_sync_settings_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_settings_close_label(inputs)
	if (locale === "ja") return ja_timing_sync_settings_close_label(inputs)
	if (locale === "hi") return hi_timing_sync_settings_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_settings_close_label(inputs)
	return en_timing_sync_settings_close_label(inputs)
});